import { Component, OnInit, Injectable, Inject, HostListener } from '@angular/core';
import { DatosBusqueda } from '../../../model/DatosBusqueda';
import { HttpModule } from '@angular/http';
import { BuscarService } from '../../../services/buscar.service';
import { DOCUMENT } from "@angular/platform-browser";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/min';
import { ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-buscador',
  templateUrl: './buscador.component.html',
  styleUrls: ['./buscador.component.css']
})
export class BuscadorComponent implements OnInit {

  mostrarTextoBuscado: boolean = false;
  mostrarPalabrasFrecuentes: boolean = true;
  /**
   * @type {string} name The page title.
   */
  name = 'Angular v4 - Applying filters to *ngFor using pipes';

  /**
   * @type {number} minYear The year of the oldest book in the json.
   */
  minYear: number = 1996;

  /**
   * @type {number} maxYear The year of the newest book in the json.
   */
  maxYear: number = 2017;

  /**
   * @type {number} numberOfBuscars The number of buscar in the JSON file, used for max attribute for limit and page.
   */
  numberOfBuscar: number;

  /**
   * @type {number} limit The number of buscar per page.
   */
  limit: number;

  /**
   * @type {number} page The current page.
   */
  page: number = 1;

  /**
   * @type {DataBuscar[]} buscar A list of buscar to output in a table.
   */
  concordancias: DatosBusqueda[];

  /**
   * @type {DatosBusqueda} filter The object containing the filter values to apply to bookfilter.
   * Could have created another entity called BuscarFilter, but it would basically have the same fields.
   */
  filter: DatosBusqueda = new DatosBusqueda();
  textobuscado: string;
  buscar: string;
  navIsFixed: boolean;



  constructor(private buscarService: BuscarService, private router: ActivatedRoute, @Inject(DOCUMENT) private document: Document) {
  }
  ngOnInit() {
    $(document).ready(function(){
      $(".subrayado").removeClass("subrayado");
      $('.active-INE').removeClass('active-INE');
      $("#main").removeClass("m-main-menu");
    });

    this.buscarService.getBuscar().subscribe(
      (buscar: DatosBusqueda[]) => {
        for (let i = 0; i < buscar.length; i++) {
          // this.concordancias.push(buscar[i]['buscar'])
        this.concordancias = buscar;
        }
      });
    // Para obtener el parametro de la url
    this.router.params.subscribe(params => {
      this.textobuscado = params['textobuscado'].toString();
      this.buscar = this.textobuscado
    });

    let node = document.createElement('script');
    // node.src = "assets/js/menu.js";
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);

  }



  @HostListener("window:scroll", [])
   onWindowScroll() {
       if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 0) {
           this.navIsFixed = true;
       } else if (this.navIsFixed && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 0) { this.navIsFixed = false; } } scrollToTop() { (function smoothscroll() { var currentScroll = document.documentElement.scrollTop || document.body.scrollTop; if (currentScroll > 0) {
               window.requestAnimationFrame(smoothscroll);
               window.scrollTo(0, currentScroll - (currentScroll / 5));
           }
       })();
   }


  onKey(value: string) {
    if (value.length >= 1) {
      this.mostrarTextoBuscado = true;
      this.mostrarPalabrasFrecuentes = false;
    }
    else {
      this.mostrarPalabrasFrecuentes = true;
      this.mostrarTextoBuscado = false;
    }
  }
  onKey2(value: string) {
    this.mostrarPalabrasFrecuentes = false;
    this.mostrarTextoBuscado = false;
    // filter = '';
  }

  menu() {

  }


}



// WEBPACK FOOTER //
// ./src/app/components/shared/buscador/buscador.component.ts